module.exports = __webpack_public_path__ + "img/game-2@2x.db35ad90.png";